import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705221aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content",
  ref: "contentRef",
  id: "ASEG-content"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "file-btns" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = { class: "price-info" }
const _hoisted_7 = { class: "price-label" }
const _hoisted_8 = { class: "price-num" }
const _hoisted_9 = { class: "tool-bar" }
const _hoisted_10 = { class: "tips-box" }
const _hoisted_11 = { class: "tips" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "pkg-col-box" }
const _hoisted_14 = { class: "pkg-text" }
const _hoisted_15 = { class: "pkg-text num" }
const _hoisted_16 = { class: "pkg-unit" }
const _hoisted_17 = { class: "pkg-text" }
const _hoisted_18 = { class: "pkg-text num" }
const _hoisted_19 = { class: "pkg-unit" }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_oio_button, {
            type: "primary",
            onClick: _ctx.downloadTemplate
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载模版")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_oio_button, {
            type: "primary",
            onClick: _ctx.importDataEvent,
            loading: _ctx.importLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode("导入")
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_oio_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.insertEvent(-1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加下一行")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(" 申请退货金额： "),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.removeDecimalZero(_ctx.totalAmount)), 1),
              _createTextVNode(" 元 ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_oio_input, {
          value: _ctx.searchVal,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchVal) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.queryData(_ctx.searchVal)), ["enter"])),
          placeholder: "请粘贴SAP编码、下单单位、申请售后数量、售后原因",
          style: {"width":"340px"}
        }, null, 8, ["value"]),
        _createVNode(_component_oio_button, {
          type: "primary",
          loading: _ctx.addLoading,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.queryData(_ctx.searchVal)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("快速添加")
          ]),
          _: 1
        }, 8, ["loading"]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ExclamationCircleOutlined, { style: {"font-size":"16px","color":"var(--oio-error-color)"} }),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.tips), 1)
        ], 512), [
          [_vShow, _ctx.tips]
        ]),
        _withDirectives(_createVNode(_component_oio_button, { onClick: _ctx.showErrorModal }, {
          default: _withCtx(() => [
            _createTextVNode(" 更多信息")
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.errorData.length]
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_oio_spin, { loading: _ctx.tableLoading }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_table, {
            border: "",
            "header-align": "center",
            ref: "tableRef",
            height: "400",
            "keep-source": "",
            "column-config": { resizable: true },
            data: _ctx.dataSource,
            "edit-config": { trigger: 'click', mode: 'cell', beforeEditMethod: _ctx.beforeEditMethod },
            "scroll-y": { enabled: true, gt: 0 },
            "row-config": { height: 80 },
            "cell-class-name": _ctx.calcCellClassName,
            onCheckboxChange: _ctx.checkboxChangeEvent,
            onCheckboxAll: _ctx.checkboxChangeEvent,
            onEditClosed: _cache[6] || (_cache[6] = (scope) => _ctx.$nextTick(() => _ctx.onChangeRow(scope)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_column, {
                type: "checkbox",
                fixed: "left",
                width: "50"
              }),
              _createVNode(_component_vxe_column, {
                type: "seq",
                title: "行号",
                fixed: "left",
                width: "50"
              }),
              _createVNode(_component_vxe_column, {
                field: "outCode",
                title: "ERP商品编码",
                "min-width": "250"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.outCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(scope.row.outCode), 1))
                    : (_openBlock(), _createBlock(_component_a_select, {
                        key: 1,
                        class: "oio-select",
                        "dropdown-class-name": "oio-select-dropdown",
                        getPopupContainer: _ctx.getPopupContainer,
                        "show-search": "",
                        placeholder: "货号、ERP商品编码、商品名称",
                        style: {"width":"100%"},
                        "default-active-first-option": false,
                        "show-arrow": false,
                        "filter-option": false,
                        "not-found-content": null,
                        options: _ctx.itemOptions,
                        onChange: (outCode) => _ctx.onSelectItemChange(outCode, scope),
                        onSearch: _ctx.onItemSearchDebounce,
                        onBlur: _ctx.clearItemOptions,
                        onFocus: _ctx.clearItemOptions,
                        onPopupScroll: _ctx.slipSelect
                      }, null, 8, ["getPopupContainer", "options", "onChange", "onSearch", "onBlur", "onFocus", "onPopupScroll"]))
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "itemName",
                title: "商品名称",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "itemCode",
                title: "商品编码",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "itemNumber",
                title: "货号",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "characteristics",
                title: "产品特性",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "priceType",
                title: "价格类型",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.priceTypeEnumList[row.priceType]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "externalMaterialGroup",
                title: "外部物料组",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "saleUnitName",
                title: "单位",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "minMarketPrice",
                title: "出厂价",
                width: "150",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "actualUnitPrice",
                title: "成交单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "applyReverseNum",
                title: "包装规格",
                "edit-render": { autofocus: 'input', placeholder: '请点击输入' },
                width: "300"
              }, {
                default: _withCtx(({ row, rowIndex }) => [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specificationDataListList[rowIndex], (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "pkg-input-col",
                        key: item.unitCode
                      }, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.unitName ?? ''), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.count ?? ''), 1),
                        _createElementVNode("div", _hoisted_16, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                      ]))
                    }), 128))
                  ])
                ]),
                edit: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: "pkg-col-box",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.tableRef?.clearEdit()), ["self","stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specificationDataListList[scope.rowIndex], (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "pkg-input-col",
                        key: item.unitCode
                      }, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.unitName), 1),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_input, {
                            value: item.count,
                            onChange: (e) => (item.count = Number(String(e.target.value).replace(/[^0-9]/g, ''))),
                            style: {"width":"100%"},
                            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.tableRef?.clearEdit()), ["enter"]))
                          }, null, 8, ["value", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_19, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "reverseUnitPrice",
                title: "售后单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "applyRefundAmount",
                title: "申请售后金额",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                title: "售后原因",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.outCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_a_select, {
                          value: scope.row?.reason?.reason,
                          options: _ctx.reasonOptions,
                          getPopupContainer: _ctx.getPopupContainer,
                          onChange: (val) => _ctx.onChangeReason(scope, val)
                        }, null, 8, ["value", "options", "getPopupContainer", "onChange"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                title: "操作",
                fixed: "right",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_oio_button, {
                    type: "link",
                    danger: "",
                    onClick: ($event: any) => (_ctx.removeRow(scope))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "edit-config", "cell-class-name", "onCheckboxChange", "onCheckboxAll"]),
          _createVNode(_component_vxe_pager, {
            perfect: "",
            total: _ctx.dataSource?.length,
            layouts: ['Total']
          }, null, 8, ["total"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.errorModal,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.errorModal) = $event)),
      title: "提示信息",
      width: 600
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_table, {
          "header-align": "center",
          border: "",
          data: _ctx.errorData,
          "max-height": 400,
          ref: "errorTableRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              type: "seq",
              width: "60"
            }),
            _createVNode(_component_vxe_column, {
              field: "msg",
              title: "提示信息"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}